import isIOS from './isIOS';

const iOS = isIOS();
const body = document.body;

let savedPosition = 0;

function blockBodyScroll() {
  if (!iOS) {
    const widthBefore = body.offsetWidth;
    body.classList.add('modal-view-is-active')
    const widthAfter = body.offsetWidth;
    body.style['padding-right'] = (widthAfter - widthBefore) + 'px';

    return
  }

  body.classList.add('modal-view-is-active-on-ios')
  savedPosition = window.scrollTop
  body.style.top = `${savedPosition * -1}`
}

function unblockBodyScroll() {
  if (!iOS) {
    body.classList.remove('modal-view-is-active')
    body.style.removeProperty('padding-right');

    return;
  }

  body.classList.remove('modal-view-is-active-on-ios')
  body.style.top = ``
  savedPosition = 0
}

export {
  blockBodyScroll,
  unblockBodyScroll,
};
